export const DEFAULT_ZH_APPS_URL = "https://web-sdk.zerohash.com/";
export const DEFAULT_ROOT_ID_PREFIX = "zerohash"
